import { render, staticRenderFns } from "./RunJavaScript.vue?vue&type=template&id=9a675b94&scoped=true"
import script from "./RunJavaScript.vue?vue&type=script&lang=js"
export * from "./RunJavaScript.vue?vue&type=script&lang=js"
import style0 from "./RunJavaScript.vue?vue&type=style&index=0&id=9a675b94&prod&lang=scss&scoped=true"
import style1 from "./RunJavaScript.vue?vue&type=style&index=1&id=9a675b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a675b94",
  null
  
)

export default component.exports